exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.loadingWrap[data-v-24a16d5c] .van-popup {\n  background-color: rgba(0, 0, 0, 0.7);\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/bj-parent-h5/src/components/loading.vue","/data/jenkins/workspace/bj-parent-h5/src/components/loading.vue"],"names":[],"mappings":";AAyBA;EACE,qCAAA;CCxBD","file":"loading.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.loadingWrap /deep/.van-popup {\n  background-color: rgba(0, 0, 0, 0.7);\n}\n",".loadingWrap /deep/ .van-popup {\n  background-color: rgba(0, 0, 0, 0.7);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24a16d5c","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/loading.vue
// module id = uDKh
// module chunks = 21